import { render } from "./UserSelector.vue?vue&type=template&id=d310917c&scoped=true"
import script from "./UserSelector.vue?vue&type=script&lang=js"
export * from "./UserSelector.vue?vue&type=script&lang=js"

import "./UserSelector.vue?vue&type=style&index=0&id=d310917c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d310917c"]])

export default __exports__